export default {
	data() {
		return {
			code: '',
			payType: '', //支付方式
			commodityList: [],
			totalprices: 0,
			detailsBox: true,
			paycenterXinxiisapprove: false,
			toPayBtn: true,
			dialogVisible: false,
			isInvoice: false,
			invoice: {
				invoice_title: '',
				invoice_type: '',
				tax_no: '',
				invoice_email: '',
				invoice_open_bank: '',
				// 发票类型
				invoice_title_type: '个人',
				invoice_address: '',
				//校验红星
				rules: {
					name: ''
				},
				invoice_email: '',
				invoice_phone: ''
            },
            // 支付显示加载中
            loading: false,
			click:false
		}
	},
	methods: {
		//个人
		cleaTax_no() {
			console.log(1)
			this.invoice.tax_no = ''
			if (this.invoice.invoice_title_type == '个人') {
				console.log(2)
				this.invoice.invoice_title = this.$store.state.name
			} else {
				console.log(3)
				this.invoice.invoice_title = ''
			}
		},
		//显示商品详情
		isDetailsBox: function() {
			this.detailsBox = !this.detailsBox;
		},
		//嵌入支付宝页面
		isPay: function(data, id) {
			let end = data.indexOf('{"status"');
			let block = data.substring(0, end);
			let div = document.createElement('div');
			div.innerHTML = block;
			document.querySelector('#paycenter').appendChild(div);
			document.forms['alipaysubmit'].submit();
		},
		//支付中心获取相应数据
		getMyorder: function() {
			// 获取课程包数据
			this.commodityList = JSON.parse(this.$route.query.commodityList);

			// 发送请求获取订单数据
			let orderId = this.$route.query.order_id;
			this.$post('orders/get', {
				id: orderId,
				token: this.$store.state.id
			}).then(res => {
				let data = res.data.result;
				this.code = data.code;
				this.totalprices = data.total;
			})

			// this.code = this.$route.query.code;
			// let arr = JSON.parse(this.$route.query.commodityList);
			// for (let id of arr) {
			//     this.$post('products/get', { id: id }).then(res => {
			//         res.data.result.id = id;
			//         this.commodityList.push(res.data.result);
			//         this.totalprices += Number.parseFloat(res.data.result.price);
			//     });
			// }
		},
		//选择不同支付方式
		goOrderDetails: function() {
			let order_id = this.$route.query.order_id;
			if (this.payType === 'zzyh') {
				if (this.invoice.invoice_title_type == '个人' && this.invoice.invoice_title == '') {
					this.$message({
						type: 'error',
						message: '请填写发票抬头'
					})
					return
				}
				if (this.invoice.invoice_title_type == '单位') {
					if (this.invoice.tax_no == '') {
						this.$message({
							type: 'error',
							message: '请填写纳税人识别号'
						})
						return
					}
					if (this.invoice.invoice_title == '') {
						this.$message({
							type: 'error',
							message: '发票抬头需填写单位全称'
						})
						return
					}

					// 要求纳税人识别号长度为:15位、17位、18位或者20位
					if (
						!(this.invoice.tax_no.length == 15 ||
							this.invoice.tax_no.length == 17 ||
							this.invoice.tax_no.length == 18 ||
							this.invoice.tax_no.length == 20)
					) {
						this.$message.error('纳税人识别号应为15位、17位、18位或20位数字和字母组成。您输入的纳税人识别号不符合要求!');
						return;
					}
					// 纳税人识别号应由字母数字组成
					const regexTaxNo = /[a-z0-9]/ig;
					if (!this.invoice.tax_no.match(regexTaxNo)) {
						this.$message({
							type: 'error',
							message: '纳税人识别号应由字母和数字组成。您输入的纳税人识别号不符合要求!'
						})
						return
					}
				}
				
				const phoneReg = /^[0-9]+.?[0-9]*$/;
				if(this.invoice.invoice_phone.length != 11 || !phoneReg.test(this.invoice.invoice_phone)){
					this.$message({
						type: 'error',
						message: '请正确填写手机号码'
					})
					return
				}


				// 发票抬头不能包含特殊符号
				// const regexSpecific = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
				// if (regexSpecific.test(this.invoice.invoice_title)) {
				// 	this.$message({
				// 		type: 'error',
				// 		message: '发票抬头请不要包含特殊符号'
				// 	})
				// 	return
				// }

				let data = {
					id: order_id,
					token: this.$store.state.id,
					invoice_type:'电子版',
					invoice_title_type:this.invoice.invoice_title_type
				}
				if (this.invoice.tax_no) {
					data.tax_no = this.invoice.tax_no
				}
				if (this.invoice.invoice_title) {
					data.invoice_title = this.invoice.invoice_title
				}
				if (this.invoice.invoice_open_bank) {
					data.invoice_open_bank = this.invoice.invoice_open_bank
				}
				if (this.invoice.invoice_address) {
					data.invoice_address = this.invoice.invoice_address
				}
				if (this.invoice.invoice_phone) {
					data.invoice_phone = this.invoice.invoice_phone
				}
				if (this.invoice.invoice_email) {
					data.invoice_email = this.invoice.invoice_email
				}
				this.$post('orders/editInvoice', data).then(res => {
                    this.loading = true;

					this.$post('orders/zz_pay', {
						order_id: order_id,
						token: this.$store.state.id
					}).then(res => {
                        this.loading = false;
						if (res.data.result.status) {
							window.location.replace(res.data.result.msg);
						} else {
							this.$messgae.error(res.data.result.msg);
						}
					});
				})

			} else if (this.payType === 'balancepay') {
                this.loading = true;
				//获取账户余额
				this.$post('users/profile', {
					token: this.$store.state.id
				}).then(res => {
					let balance = 0;
					if (res.data.status === 'success') {
						let balance1 = res.data.result.balance;
						//计算支付后的余额
						balance = (balance1 * 100 - this.totalprices * 100) / 100;
						if (balance < 0) {
                            this.loading = false;
							this.$message({
								showClose: true,
								message: '余额不足',
								type: 'error'
							});
						} else {
							//更新账户余额
							this.updataBalance(balance);

							// 向余额日志表中插入数据
							// this.createLog(balance, this.totalprices)
						}
					}
				})
			} else {
				let model = document.querySelector('#modal-pay');
				UIkit.modal(model).show();
			}
		},
		//更新账户余额
		updataBalance(balance) {
			let orderId = this.$route.query.order_id;
			// console.log(balance);
			this.$post('users/balance_token', {
				balance: balance,
				token: this.$store.state.id,
				total: this.totalprices,
				order_id: orderId
			}).then(res => {
				if (res.data.status === 'success') {
					// 更改订单状态
					this.updataOrder();
				} else {
					this.$message({
						showClose: true,
						message: '支付失败',
						type: 'error'
					});
				}
			})

		},
		// 更改订单状态
		updataOrder() {
			let date = this.getPayDate()
			// console.log(date)

			this.$post('orders/edit_state', {
				pay_type: 5,
				state: 2,
				id: this.$route.query.order_id,
				token: this.$store.state.id,
				pay_date: date
			}).then(res => {
				// console.log(res.data.status);
				if (res.data.status === 'success') {
					// this.toPayBtn = true
					// console.log(this.$route.query.order_id);
					this.$router.replace({
						path: '/myorderdetails',
						query: {
							order_id: this.$route.query.order_id,
							categoryList: this.$route.query.commodityList
						}
					});
				} else {
					this.$message({
						showClose: true,
						message: '订单生成失败',
						type: 'error'
					});
                }
                this.loading = false;
			})
		},
		//选择支付方式
		changeBorder(who) {
			switch (who) {
				case 'zzyh':
					// 重置发票信息
					this.isInvoice = true;
					this.invoice.invoice_title_type = '个人';
					this.invoice.invoice_title = this.$store.state.name

					this.payType = 'zzyh';
					this.$refs.zzyh.style.border = "1px solid #21a557";
					this.$refs.balance.style.border = "1px solid #cccccc";
					this.toPayBtn = true;
					this.$refs.zzyhSjx.style.backgroundPosition = "0 -161px";
					this.$refs.balanceSjx.style.backgroundPosition = "0 -187px";
					this.paycenterXinxiisapprove = false;
					break;

				case 'balance':
					// 重置发票信息
					this.isInvoice = false;
					this.invoice = {
						invoice_title: '',
						invoice_type: '',
						tax_no: '',
						invoice_email: '',
						invoice_open_bank: '',
						// 发票类型
						invoice_title_type: '余额支付'
					};

					this.payType = 'balancepay';
					this.$refs.balance.style.border = "1px solid #21a557";
					this.$refs.zzyh.style.border = "1px solid #cccccc";
					this.toPayBtn = true;
					this.$refs.balanceSjx.style.backgroundPosition = "0 -161px";
					this.$refs.zzyhSjx.style.backgroundPosition = "0 -187px";
					this.paycenterXinxiisapprove = false;
					break;
			}
		},
		//跳转商品页面
		commodityDetails: function(id) {
			this.$router.push({
				path: '/classdetails',
				query: {
					id: id
				}
			});

		},

		/**
		 * 插入用户余额更改记录到用户余额日志表
		 * @param {*} balance 购买完成后的用户余额
		 * @param {*} consumption 本次支付消费金额
		 */
		// createLog(balance, consumption) {
		//     // console.log('balance', balance)
		//     // console.log('consumption', consumption)
		//     this.$post('user_log/create_by_token', {
		//         count: consumption,
		//         token: this.$store.state.id,
		//         content: '支出' + consumption + '元',
		//         balance: balance,
		//         shop_id: this.$store.state.store.id
		//     })
		// },

		// 获取当前的支付时间
		getPayDate() {
			let date = new Date()
			let year = date.getFullYear()
			let month = this.addZero(date.getMonth() + 1)
			let day = this.addZero(date.getDate())
			let hour = this.addZero(date.getHours())
			let minute = this.addZero(date.getMinutes())
			let second = this.addZero(date.getSeconds())
			return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
		},

		// 补0
		addZero(number) {
			if (number < 10) {
				return '0' + number
			} else {
				return number
			}
		}

	},
	created() {
		this.getMyorder();
		// console.log(this.$route.query);
		// let order_id=this.$route.query.order_id;
		// this.lastAddress='?id='+order_id+'&token?';
	},
	mounted() {
		// this.$refs.changeBorder.style['border']='1px solid #21a557';
		document.title = '支付中心';
	},
}
